import Banner from 'components/blog/banner/banner';
import BlogContent from 'components/blog/blog-content/blog-content';
import Breadcrumb from 'components/seo/breadcrumb/breadcrumb';
import { cleanDictForJson } from 'utils/secure-json';
import CtaStickyBanner from 'components/home/cta-sticky-banner/cta-sticky-banner';
import CustomHead from 'core/custom-head';
import Footer from 'components/footer/footer';
import Header from 'components/home/header';
import { Header as HeaderSection } from 'components/header/header';
import LandingSection from 'components/landing/components/landing-section';
import { PageInfoContextProvider } from 'context/PageInfoContext';
import PropTypes from 'prop-types';
import ScriptContainer from 'components/container/script-container';
import Scroller from 'components/home/scroller';
import SeoTracking from 'components/seo/tracking/seo-tracking';
import Spacer from 'core/spacer';
import ViewNoteButton from 'components/blog/view-note-button/view-note-button';
import withHydrationOnDemand from 'react-hydration-on-demand';

const BlogContentH = withHydrationOnDemand({ on: ['visible'] })(BlogContent);
const FooterH = withHydrationOnDemand({ on: ['visible'] })(Footer);
const BannerH = withHydrationOnDemand({ on: ['visible'] })(Banner);

const BlogPost = ({ payload }) => {
    return (
        <div style={{ backgroundColor: '#ec008b', height: '100vh', width: '100vw' }}>
            <ScriptContainer breadcrumbList={payload.page_context.page_breadcrumb_list}>
                <SeoTracking templateName="contentap" isRemote={payload.page_context.is_remote} pageCode={payload.page_context.code} />
                <CustomHead pageInfo={payload} />
                <PageInfoContextProvider data={payload}>
                    <div>
                        <Scroller />
                        <Header navbarType="blog-post" />
                        <ViewNoteButton />
                        <CtaStickyBanner isBlog hideMobile/>
                        <HeaderSection />
                        <LandingSection disableBottomPadding disableTopPadding disableGradient>
                            <Breadcrumb />
                            <Spacer />
                        </LandingSection>
                        <section itemScope itemType="https://schema.org/BlogPosting">
                            <BannerH />
                            <BlogContentH
                                rawContent={payload.page_context.content}
                                relatedNoteList={payload.page_context.page_related_notes}
                            />
                        </section>
                    </div>
                    <FooterH />
                </PageInfoContextProvider>
            </ScriptContainer>
        </div>
    );
};

export async function getServerSideProps ({ locale, req }) {
    return {
        props: {
            messages: (
                await import(`../messages/blog-post/${locale}.json`)
            ).default,
            culture: locale,
            payload: cleanDictForJson(req.apiData.data)
        }
    };
}

BlogPost.propTypes = {
    culture: PropTypes.string,
    payload: PropTypes.object
};

export default BlogPost;
